export class CollectiveAgreementRateListDTO {

    id: string;

    name: string;

}
